import * as React from 'react';

import { RequestDemandBanner } from '../../RequestDemand/components/RequestDemandBanner';
import { isElementShown } from './utils/isElementShown';

import * as styles from './SimilarOffersBanner.css';
import * as BannerImage from './assets/similar-offers-banner.png';

export interface IRealtorDemandProps {
  onViewSimilarOffers(): void;
  onBannerViewed(): void;
}

export const SimilarOffersBanner: React.FC<IRealtorDemandProps> = ({ onViewSimilarOffers, onBannerViewed }) => {
  const containerRef = React.useRef<HTMLDivElement | null>(null);
  const [isBannerViewed, setBannerViewed] = React.useState<boolean>(false);

  const handleBannerViewed = React.useCallback(() => {
    if (!isBannerViewed && isElementShown(containerRef.current)) {
      onBannerViewed();
      setBannerViewed(true);
    }
  }, [isBannerViewed, onBannerViewed]);

  React.useEffect(() => {
    window.addEventListener('scroll', handleBannerViewed);

    return () => window.removeEventListener('scroll', handleBannerViewed);
  }, [handleBannerViewed]);

  return (
    <div className={styles['container']} ref={containerRef}>
      <RequestDemandBanner
        title="Похожие объявления"
        buttonAction={onViewSimilarOffers}
        buttonText="Смотреть"
        image={BannerImage}
        text="Мы подобрали варианты, которые могут вам понравиться"
        withoutBorders
      />
    </div>
  );
};

SimilarOffersBanner.displayName = 'SimilarOffersBanner';
